"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabsNeoDark = exports.tabsNeoLight = exports.tabsNovoDark = exports.tabsNovo = exports.tabs = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const tabs = {
    isClassic: true,
    fontFamily: font_const_1.default.family,
    fontSize: font_const_1.default.sizeSm,
    fontWeight: font_const_1.default.weightDefault,
    lineHeight: font_const_1.default.lineHeightSm,
    letterSpacing: 'normal',
    selectedFontFamily: font_const_1.default.family,
    selectedFontSize: font_const_1.default.sizeSm,
    selectedFontWeight: font_const_1.default.weightDefault,
    selectedLineHeight: font_const_1.default.lineHeightSm,
    selectedLetterSpacing: '0',
    tabTextColorDark: color_const_1.default.cloudyBlue,
    tabTextColorDarkHover: color_const_1.default.white,
    tabTextColorDarkActive: color_const_1.default.white,
    tabTextColorDarkDisabled: color_const_1.default.steel700,
    tabTextColorLight: color_const_1.default.pickledBluewood800,
    tabTextColorLightHover: color_const_1.default.dodgerBlue,
    tabTextColorLightActive: color_const_1.default.dodgerBlue,
    tabTextColorLightDisabled: color_const_1.default.cloudyBlue,
    tabHeight: size_const_1.default.large,
    tabMaxWidth: 'initial',
    tabMinWidth: 'initial',
    tabPadding: `0 ${size_const_1.default.default2x}`,
    tabBorderRadius: 0,
    tabBorderTopSize: 0,
    tabBorderRightSize: 0,
    tabBorderBottomSize: size_const_1.default.smallest,
    tabBorderLeftSize: 0,
    tabBorderColorDark: 'transparent',
    tabBorderColorDarkHover: 'transparent',
    tabBorderColorDarkActive: color_const_1.default.goldenBell,
    tabBorderColorDarkDisabled: 'transparent',
    tabBorderColorLight: 'transparent',
    tabBorderColorLightHover: 'transparent',
    tabBorderColorLightActive: color_const_1.default.dodgerBlue,
    tabBorderColorLightDisabled: 'transparent',
    tabBackgroundDark: 'transparent',
    tabBackgroundDarkHover: 'transparent',
    tabBackgroundDarkActive: 'transparent',
    tabBackgroundDarkDisabled: 'transparent',
    tabBackgroundLight: 'transparent',
    tabBackgroundLightHover: 'transparent',
    tabBackgroundLightActive: 'transparent',
    tabBackgroundLightDisabled: 'transparent',
    tabTransitionTime: timing_const_1.default.fast,
    tabsBarBackgroundDark: color_const_1.default.pickledBluewood,
    tabsBarBackgroundLight: color_const_1.default.white,
    tabsBarBorderColorDark: color_const_1.default.pickledBluewood,
    tabsBarBorderColorLight: color_const_1.default.cloudyBlue300,
    tabsBarBorderTopSize: 0,
    tabsBarBorderRightSize: 0,
    tabsBarBorderBottomSize: '1px',
    tabsBarBorderLeftSize: 0,
    tabsBarPadding: `0 ${size_const_1.default.medium}`,
    tabsBarBorderRadius: 0,
};
exports.tabs = tabs;
const tabsNovo = {
    isClassic: false,
    fontFamily: light.body01.fontFamily,
    fontSize: light.body01.fontSize,
    fontWeight: light.body01.fontWeight,
    lineHeight: light.body01.lineHeight,
    letterSpacing: light.body01.letterSpacing,
    selectedFontFamily: light.bodyBold01.fontFamily,
    selectedFontSize: light.bodyBold01.fontSize,
    selectedFontWeight: light.bodyBold01.fontWeight,
    selectedLineHeight: light.bodyBold01.lineHeight,
    selectedLetterSpacing: light.bodyBold01.letterSpacing,
    textColor: light.textColor02,
    tabBorderColor: 'transparent',
    tabBackground: 'transparent',
    textColorHover: light.textColor01,
    tabBorderColorHover: light.ui04,
    tabBackgroundHover: 'transparent',
    textColorFocus: light.textColor01,
    tabBorderColorFocus: light.focus01,
    tabBackgroundFocus: 'transparent',
    textColorActive: light.action04,
    tabBorderColorActive: light.action04,
    tabBackgroundActive: 'transparent',
    textColorDisabled: light.disabled02,
    tabBorderColorDisabled: 'transparent',
    tabBackgroundDisabled: 'transparent',
    tabGap: light.spacing02,
    tabHeight: '52px',
    tabMaxWidth: 'initial',
    tabMinWidth: 'initial',
    tabPadding: `0 ${light.spacing03}`,
    tabBorderRadius: 0,
    tabBorderTopSize: 0,
    tabBorderRightSize: 0,
    tabBorderBottomSize: '2px',
    tabBorderLeftSize: 0,
    tabBorderSizeFocus: '2px',
    tabTransitionTime: '150ms',
    tabsBarBackground: 'transparent',
    tabsBarBorderColor: light.ui01,
    tabsBarBorderTopSize: 0,
    tabsBarBorderRightSize: 0,
    tabsBarBorderBottomSize: '1px',
    tabsBarBorderLeftSize: 0,
    tabsBarPadding: 0,
    tabsBarBorderRadius: 0,
};
exports.tabsNovo = tabsNovo;
const tabsNovoDark = {
    ...tabsNovo,
    textColor: dark.textColor02,
    textColorHover: dark.textColor01,
    textColorFocus: dark.textColor01,
    textColorActive: dark.action04,
    tabBorderColorActive: dark.action04,
    textColorDisabled: dark.disabled02,
    tabsBarBorderColor: dark.ui01,
    tabBorderColorHover: dark.ui04,
    tabBorderColorFocus: dark.focus01,
};
exports.tabsNovoDark = tabsNovoDark;
const tabsNeoLight = {
    ...tabsNovo,
    textColor: neoLight.textColor02,
    textColorHover: neoLight.textColor01,
    tabBorderColorHover: neoLight.ui04,
    textColorFocus: neoLight.textColor01,
    tabBorderColorFocus: neoLight.focus01,
    textColorActive: neoLight.action04,
    tabBorderColorActive: neoLight.action04,
    textColorDisabled: neoLight.disabled02,
    tabsBarBorderColor: neoLight.ui01,
};
exports.tabsNeoLight = tabsNeoLight;
const tabsNeoDark = {
    ...tabsNovoDark,
    textColor: neoDark.textColor02,
    textColorHover: neoDark.textColor01,
    textColorFocus: neoDark.textColor01,
    textColorActive: neoDark.action04,
    tabBorderColorActive: neoDark.action04,
    textColorDisabled: neoDark.disabled02,
    tabsBarBorderColor: neoDark.ui01,
    tabBorderColorHover: neoDark.ui04,
    tabBorderColorFocus: neoDark.focus01,
};
exports.tabsNeoDark = tabsNeoDark;
